import CapitalCallPortionList from "./CapitalCallPortionList";

export default CapitalCallPortionList;
